import { useMatchMediaQuery } from '@dh-io-owpi/shared/src/composables/useMediaQuery';

export const isSmallVersion = useMatchMediaQuery('mq1', 'mq2', 'mq3');
